// test724
(724 && 0);
